import {immerable} from "immer";

export default class Immerable {
    [immerable] = true;
}